import script from "./MypageMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MypageMessage.vue?vue&type=script&setup=true&lang=ts"

import "./mypage.css?vue&type=style&index=0&id=48fbc784&scoped=true&lang=css"
import "./MypageMessage.vue?vue&type=style&index=1&id=48fbc784&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fbc784"]])

export default __exports__